import React from "react";
import { Box, Typography, Slider, TextField } from "@mui/material";
import { Bar } from "react-chartjs-2";
import { Chart as ChartJS, CategoryScale, LinearScale, BarElement, Title, Tooltip, Legend } from 'chart.js';
import styles from "./PriceFilter.module.css";

ChartJS.register(
  CategoryScale,
  LinearScale,
  BarElement,
  Title,
  Tooltip,
  Legend
);

const PriceFilter = ({ maxPrice, selectedPriceRange, setSelectedPriceRange, dataValues }) => {
  const tiers = 8;
  const priceStep = Math.ceil(maxPrice / tiers);

  const labels = Array.from({ length: tiers }, (_, index) => `${index * priceStep} - ${(index + 1) * priceStep}`);
  
  const barColors = Array.from({ length: tiers }, (_, index) => {
    const min = index * priceStep;
    const max = (index + 1) * priceStep;
    const isSelected = selectedPriceRange[0] <= max && selectedPriceRange[1] >= min;
    return isSelected ? "rgba(255, 149, 0, 1)" : "rgba(255, 149, 0, 0)";
  });

  const borderColors = Array.from({ length: tiers }, () => "rgba(255, 149, 0, 1)");

  const data = {
    labels,
    datasets: [
      {
        label: "Price Distribution",
        data: dataValues,
        backgroundColor: barColors,
        borderColor: borderColors,
        borderWidth: 2,
      },
    ],
  };

  const options = {
    responsive: true,
    plugins: {
      legend: { display: false },
      tooltip: { enabled: false }
    },
    scales: {
      x: { 
        grid: { display: false },
        ticks: { display: false } // Hides X-axis ticks
      },
      y: { 
        grid: { display: false }, 
        ticks: { display: false } // Hides Y-axis ticks
      },
    },
  };

  const handleSliderChange = (event, newValue) => {
    setSelectedPriceRange(newValue);
  };

  const handleMinInputChange = (e) => {
    const value = parseInt(e.target.value) || 0;
    if (value <= selectedPriceRange[1]) {
      setSelectedPriceRange([value, selectedPriceRange[1]]);
    }
  };

  const handleMaxInputChange = (e) => {
    const value = e.target.value === '' ? '' : parseInt(e.target.value, 10); // Allow empty input
  
    if (value === '' || (value >= selectedPriceRange[0] && value <= maxPrice)) {
      setSelectedPriceRange([selectedPriceRange[0], value === '' ? maxPrice : value]);
    }
  };

  return (
    <Box className={styles.priceElement}>
      <Bar data={data} options={options} className={styles.priceGraph} />

      <Slider
        value={selectedPriceRange}
        onChange={handleSliderChange}
        min={0}
        max={maxPrice}
        valueLabelDisplay="auto"
        sx={{
          color: 'var(--colors-orange)',
          '& .MuiSlider-track': {
            backgroundColor: 'var(--colors-orange)',
          },
          '& .MuiSlider-rail': {
            border: '2px solid var(--colors-orange)',
            backgroundColor: 'transparent',
          },
          '& .MuiSlider-thumb': {
            backgroundColor: 'var(--colors-orange)',
          },
        }}
      />

      <Box className={styles.priceRangeDisplay}>
        <TextField
          value={selectedPriceRange[0]}
          onChange={handleMinInputChange}
          size="small"
          variant="standard"
          inputProps={{ style: { fontSize: 12, textAlign: 'left' } }}
          className={styles.inputField}
        />
        <TextField
          value={selectedPriceRange[1]}
          onChange={handleMaxInputChange}
          size="small"
          variant="standard"
          inputProps={{ style: { fontSize: 12, textAlign: 'right' } }}
          className={styles.inputField}
        />
      </Box>
    </Box>
  );
};

export default PriceFilter;